import { Component, ViewChild, OnInit } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { ConfirmService } from '../../../core/components/confirm/confirm.service';
import { TicketsService } from './tickets.service';
import { Ticket } from '../../../core/modelos/ticket';
import { FileManagerService } from '../file-manager/file-manager.service';
import { NotificacionesService } from '../../../core/notificaciones/notificaciones.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DocumentoTicket } from '../../../core/modelos/documento_ticket';
import { TranslateService } from '@ngx-translate/core';
import { ActivosService } from '../activos/activos.service';

/**
 * @title Data table with sorting, pagination, and filtering.
 */
@Component({
    selector: 'fuse-tickets-datatable',
    templateUrl: './tickets.component.html',
    styleUrls: ['./tickets.component.scss']
})
export class TicketsComponent implements OnInit {
    // displayedColumns = ['titulo', 'estado', 'prioridad', 'solicitante', 'asignado', 'activo', 'acciones'];
    displayedColumns = ['titulo', 'acciones', 'asociado', 'estado', 'prioridad', 'solicitante', 'asignado', 'activo', 'fecha'];
    dataSource: MatTableDataSource<Ticket>;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    // Usuario conectado
    user: { usuario: string };
    // Incidencias
    tickets: Array<Ticket>;

    idActivo: number;

    constructor(
        private ticketsService: TicketsService,
        private confirmService: ConfirmService,
        private fileService: FileManagerService,
        private notificaciones: NotificacionesService,
        private router: Router,
        private fileManagerSrv: FileManagerService,
        private activatedRoute: ActivatedRoute,
        private translate: TranslateService,
        private activosService: ActivosService,
    ) {
         // Traigo el ticket por parametro
         this.activatedRoute.params.subscribe(params => {
            this.idActivo = params['idActivo'];

            // notify about the new activo
            this.activosService.setCurrentActivo(this.idActivo)
        });
    }

    ngOnInit() {
        if (!this.idActivo) {
            this.getTickets();
        } else {
            this.getTicketsActivo();
        }
    }
    addTicket() {
        if (this.idActivo) {
            this.router.navigate(['/tickets/nuevo/' + this.idActivo]);
        } else {
            this.ticketsService.setKey('');
            this.ticketsService.setVersion('');
            this.router.navigate(['/tickets/nuevo']);
        }
    }

    getTickets() {
        this.ticketsService.getTickets().subscribe(
            data => {
                if (data.success) {
                    this.tickets = data.items;
                    // Assign the data to the data source for the table to render
                    this.dataSource = new MatTableDataSource(this.tickets);

                    // Esto estaba en el afterViewInit
                    this.dataSource.paginator = this.paginator;

                    // Indica de dónde sacar los datos para ordenar
                    this.dataSource.sortingDataAccessor = (item, property) => {
                        switch (property) {
                          case 'fecha': return new Date(item.created_at);
                          case 'titulo': return item.titulo.toLocaleLowerCase();
                          case 'asociado': return item.document_key ? '1' : '0';
                          case 'solicitante': return item.solicitante.nombre.toLocaleLowerCase();
                          case 'asignado': return item.asignado.nombre.toLocaleLowerCase();
                          case 'activo': {
                              if (item.activo) {
                                  return item.activo.nombre.toLocaleLowerCase();
                              }
                            }
                            break;
                          default: return item[property];
                        }
                      };

                    this.dataSource.sort = this.sort;

                    // Traduzco etiqueta si es español
                    if (this.translate.currentLang === 'es') {
                        this.paginator._intl.itemsPerPageLabel = this.notificaciones.mensajes.IdiomaActual.MensajesGenerales.ItemsPorPagina;
                    }

                } else {
                    // CONTROLAR ERROR
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Tickets.SinTickets);
                }
            },
            err => {
                // CONTROLAR ERROR
                this.notificaciones.errorServidor(err.status);
            }
        );
    }
    getTicketsActivo() {
        this.ticketsService.getTicketFromActivo(this.idActivo).subscribe(
            data => {
                if (data.success) {
                    this.tickets = data.items;
                    this.dataSource = new MatTableDataSource(this.tickets);
                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.sort;
                    // Traduzco etiqueta si es español
                    if (this.translate.currentLang === 'es') {
                        this.paginator._intl.itemsPerPageLabel = this.notificaciones.mensajes.IdiomaActual.MensajesGenerales.ItemsPorPagina;
                    }
                } else {
                    // CONTROLAR ERROR
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Tickets.SinTickets);
                }
            },
            err => {
                // CONTROLAR ERROR
                this.notificaciones.errorServidor(err.status);
            }
        );
    }
    applyFilter(filterValue: string) {
        // Ojo, el filtro que viene por defecto no tiene en cuenta estado, tipologia, etc porque son objetos...
        /*
        * filterValue = filterValue.trim(); // Remove whitespace
        * filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        * this.dataSource.filter = filterValue;
        */

        // Añado este filtro que incorpora los campos que le digamos
        this.dataSource.data = this.tickets;

        if (filterValue && filterValue.trim() !== '') {
            this.dataSource.data = this.dataSource.data.filter(
                ticket => {

                    if (ticket.titulo.toLowerCase().includes(filterValue.toLowerCase())) {
                        return ticket.titulo.toLowerCase().includes(filterValue.toLowerCase());
                    }
                    else if (ticket.estado.toLowerCase().includes(filterValue.toLowerCase())) {
                        return ticket.estado.toLowerCase().includes(filterValue.toLowerCase());
                    }
                    else if (ticket.prioridad.toLowerCase().includes(filterValue.toLowerCase())) {
                        return ticket.prioridad.toLowerCase().includes(filterValue.toLowerCase());
                    }
                    else if (ticket.solicitante.nombre.toLowerCase().includes(filterValue.toLowerCase())) {
                        return ticket.solicitante.nombre.toLowerCase().includes(filterValue.toLowerCase());
                    }
                    else if (ticket.asignado.nombre.toLowerCase().includes(filterValue.toLowerCase())) {
                        return ticket.asignado.nombre.toLowerCase().includes(filterValue.toLowerCase());
                    }
                    else if (ticket.activo.nombre.toLowerCase().includes(filterValue.toLowerCase())) {
                        return ticket.activo.nombre.toLowerCase().includes(filterValue.toLowerCase());
                    }
                }
            );
        }
    }
    delete(ticket: Ticket) {
        let anexos;
        if (ticket.documentos){
            anexos = ticket.documentos.slice();
        }
        this.confirmService.confirm(
            this.notificaciones.mensajes.IdiomaActual.Tickets.TituloBorrar,
            this.notificaciones.mensajes.IdiomaActual.Tickets.MensajeBorrar).subscribe(
                result => {
                    if (result) {
                        this.ticketsService.deleteTicket(ticket.id).subscribe(
                            data => {
                                if (data.success) {
                                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Tickets.TicketBorrado);
                                    if (anexos){
                                        anexos.forEach(anexo => {
                                            this.borrarAnexo(anexo);
                                        });
                                    }
                                    this.getTickets();
                                } else {
                                    // CONTROLAR ERROR
                                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Tickets.TicketNOBorrado);
                                }
                            },
                            err => {
                                // CONTROLAR ERROR
                                this.notificaciones.errorServidor(err.status);
                            }
                        );
                    }
                }
            );
    }
    borrarAnexo(anexo: DocumentoTicket) {
        this.fileManagerSrv.deleteAnexo(anexo).send(function (error) {
            if (error) {
                // TODO CONTROLAR ERROR
                console.log('Fichero no borrado');
            }
            else {
                // EXITO
            }
        });
    }
    descargarFichero(ticket: Ticket) {
        if (ticket.document_key) {
            this.fileService.descargarFichero(ticket.document_key, ticket.document_version);
        } else {
            // El ticket no tiene un documento asociado
            this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Tickets.SinDocumento);
        }
    }

    traducirEstado(estado: string): string {
        switch (estado) {
            case 'abierta': return this.translate.instant('TICKETS.EDITAR.ESTADO.ABIERTA');
            case 'procesando': return this.translate.instant('TICKETS.EDITAR.ESTADO.PROCESANDO');
            case 'cerrada': return this.translate.instant('TICKETS.EDITAR.ESTADO.CERRADA');

            default:
                break;
        }
    }

    traducirPrioridad(prioridad: string): string {
        switch (prioridad) {
            case 'alta': return this.translate.instant('TICKETS.EDITAR.PRIORIDAD.ALTA');
            case 'media': return this.translate.instant('TICKETS.EDITAR.PRIORIDAD.MEDIA');
            case 'baja': return this.translate.instant('TICKETS.EDITAR.PRIORIDAD.BAJA');

            default:
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/tickets/tickets.component.ts